import React, { Fragment} from 'react';
import { Helmet } from "react-helmet";
import donornotfoundImage from '../Assets/images/donor-x-404.svg';

function NotFoundPage(){
return(
    <>
        <Helmet>
            <title>DonorX | 404 Not Found</title>
        </Helmet>
        <div className='el-middle '>
            <div className="el-middle-wrapper">
                <div className='mt-5 text-center'>
                    <img src={donornotfoundImage} alt="Not Found Picture" />
                    <h1 className="el-title el-404-title"><span>404</span> Not Found.</h1>   
                    <h5 className='mt-5 mb-2'>We couldn’t find the page you’re looking for. Maybe it’s hiding, moved, or just doesn’t exist anymore.</h5> 
                    <h5>Or, you might not have permission to view this content.</h5> 
                </div>                
            </div>   
        </div>
    </>
);

}
export default NotFoundPage;